module.exports = __webpack_public_path__ + "static/media/39.2c1afb4e.png";